import React, { useEffect, useRef } from 'react';

import Button, { ButtonGroup, LoadingButton } from '@atlaskit/button';
import { useAccountsMapping } from 'src/services/accountsMapping';
import { redirectToRuleChangeValidation } from 'src/services/webhooksValidator';

import jira from 'src/lib/api/jira';

import ErrorMessage from 'src/views/components/ErrorMessage';

import { RuleFormContext, useIssuesMetadata, useRuleForm } from './components/RuleFormContext';
import RulesFormStateless from './RulesFormStateless';

const RuleForm = () => {
  const { onSubmit, isSubmitting, submitError, submitResponse, values, touched, errors, onChange, onBlur, name } = useRuleForm();
  const initValues = useRef(values);

  const { error: metadataLoadingError } = useIssuesMetadata();
  const [accountsMapping, loadingAccountsMapping] = useAccountsMapping();

  useEffect(() => {
    if (submitResponse && !loadingAccountsMapping) {
      if (accountsMapping?.metadata?.disable_automatic_webhooks_update) {
        jira.closeCurrentModal();
      } else {
        redirectToRuleChangeValidation(initValues.current, submitResponse);
      }
    }
  }, [submitResponse, loadingAccountsMapping, accountsMapping]);

  return (
    <form onSubmit={onSubmit}>
      {metadataLoadingError && <ErrorMessage error={['Failed to load Jira metadata.', metadataLoadingError]}/>}
      <RulesFormStateless {...{ values, touched, errors, onChange, onBlur, name }}/>
      {submitError && <div style={{ marginTop: 30 }}><ErrorMessage error={submitError}/></div>}
      <div style={{ paddingTop: 100, paddingBottom: 24, display: 'flex', justifyContent: 'flex-end' }}>
        <ButtonGroup>
          <Button onClick={() => jira.closeCurrentModal()}>Cancel</Button>
          <LoadingButton type="submit" appearance="primary" isLoading={isSubmitting} isDisabled={Boolean(metadataLoadingError)}>Save</LoadingButton>
        </ButtonGroup>
      </div>
    </form>
  );
};

const RuleFormWithContext = ({ rule, onSave, readonly }) => {
  return (
    <RuleFormContext initRule={rule} onSave={onSave} debug={false} readonly={readonly}>
      <RuleForm/>
    </RuleFormContext>
  );
};

export default RuleFormWithContext;
